var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {},
    [
      _c(
        "div",
        {
          staticClass: "w-100 popupmodal position-fixed p-3",
          class: [
            _vm.popupmodalActive ? "open" : "",
            _vm.theme == "white" ? "text-dark" : "text-white",
          ],
        },
        [
          _c(
            "div",
            {
              staticClass:
                "w-100 popupmodal__inner d-flex align-items-center justify-content-center",
              class: [
                _vm.theme == "dark"
                  ? "bg-fourth-" + _vm.theme
                  : "bg-specialbackground-" + _vm.theme,
              ],
            },
            [
              _c(
                "svg",
                {
                  staticStyle: { "enable-background": "new 0 0 78.369 78.369" },
                  attrs: {
                    version: "1.1",
                    id: "Capa_1",
                    xmlns: "http://www.w3.org/2000/svg",
                    "xmlns:xlink": "http://www.w3.org/1999/xlink",
                    x: "0px",
                    y: "0px",
                    width: "24px",
                    height: "18px",
                    viewBox: "0 0 78.369 78.369",
                    "xml:space": "preserve",
                  },
                },
                [
                  _c("g", [
                    _c("path", {
                      attrs: {
                        fill: _vm.svgcolor1,
                        d: "M78.049,19.015L29.458,67.606c-0.428,0.428-1.121,0.428-1.548,0L0.32,40.015c-0.427-0.426-0.427-1.119,0-1.547l6.704-6.704\n                    c0.428-0.427,1.121-0.427,1.548,0l20.113,20.112l41.113-41.113c0.429-0.427,1.12-0.427,1.548,0l6.703,6.704\n                    C78.477,17.894,78.477,18.586,78.049,19.015z",
                      },
                    }),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c("p", { staticClass: "pl-5" }, [
                _vm._v(_vm._s(_vm.t("general.basketsuccess"))),
              ]),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "w-100 popupmodal position-fixed p-3",
          class: [
            _vm.popupmodalFailureActive ? "open" : "",
            _vm.theme == "white" ? "text-dark" : "text-white",
          ],
        },
        [
          _c(
            "div",
            {
              staticClass:
                "w-100 popupmodal__inner d-flex align-items-center justify-content-center",
              class: [
                _vm.theme == "dark"
                  ? "bg-fourth-" + _vm.theme
                  : "bg-specialbackground-" + _vm.theme,
              ],
            },
            [
              _c(
                "svg",
                {
                  staticStyle: { "enable-background": "new 0 0 78.369 78.369" },
                  attrs: {
                    version: "1.1",
                    id: "Capa_1",
                    xmlns: "http://www.w3.org/2000/svg",
                    "xmlns:xlink": "http://www.w3.org/1999/xlink",
                    x: "0px",
                    y: "0px",
                    width: "24px",
                    height: "18px",
                    viewBox: "0 0 78.369 78.369",
                    "xml:space": "preserve",
                  },
                },
                [
                  _c("g", [
                    _c("path", {
                      attrs: {
                        fill: _vm.svgcolor1,
                        d: "M78.049,19.015L29.458,67.606c-0.428,0.428-1.121,0.428-1.548,0L0.32,40.015c-0.427-0.426-0.427-1.119,0-1.547l6.704-6.704\n                    c0.428-0.427,1.121-0.427,1.548,0l20.113,20.112l41.113-41.113c0.429-0.427,1.12-0.427,1.548,0l6.703,6.704\n                    C78.477,17.894,78.477,18.586,78.049,19.015z",
                      },
                    }),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c("p", { staticClass: "pl-5" }, [
                _vm._v(_vm._s(_vm.t("general.basketaddfailure"))),
              ]),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _vm.activatefilter == 1
        ? _c("filters", {
            attrs: {
              theme: _vm.theme,
              filters: _vm.propertyfilters,
              amount: _vm.cardsFiltered.length,
            },
            on: { applyFilters: _vm.getFilters },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.cardsFiltered.length != 0
        ? _c(
            "div",
            _vm._l(_vm.cardsFiltered, function (card, index) {
              return _c(
                "div",
                {
                  staticClass:
                    "d-flex px-3 px-lg-0 flex-column sparepartsproductselection__productlist__item",
                  class:
                    "sparepartsproductselection__productlist__item--" +
                    _vm.theme,
                },
                [
                  _c("div", { staticClass: "d-flex" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "sparepartsproductselection__productlist__item__img",
                      },
                      [
                        card.fabricId &&
                        card.img != null &&
                        card.img !=
                          "//suncomfort.glatz.com/media/glatz_thumbnail.png" &&
                        card.img != ""
                          ? _c("div", {
                              staticClass:
                                "sparepartsproductselection__productlist__item__img__inner sparepartsproductselection__productlist__item__img__inner--fabric",
                              class: "bg-specialbackground-" + _vm.theme,
                              style: {
                                backgroundImage: "url(" + card.img + ")",
                              },
                            })
                          : card.type[0].id == 85 &&
                            card.img != null &&
                            card.img !=
                              "//suncomfort.glatz.com/media/glatz_thumbnail.png" &&
                            card.img != ""
                          ? _c("div", {
                              staticClass:
                                "sparepartsproductselection__productlist__item__img__inner sparepartsproductselection__productlist__item__img__inner--fabric",
                              class: "bg-specialbackground-" + _vm.theme,
                              style: {
                                backgroundImage: "url(" + card.img + ")",
                              },
                            })
                          : _c("div", {
                              staticClass:
                                "sparepartsproductselection__productlist__item__img__inner",
                              class: "bg-specialbackground-" + _vm.theme,
                              style: {
                                backgroundImage: "url(" + card.img + ")",
                              },
                            }),
                        _vm._v(" "),
                        card.repairlevel != null && card.repairlevel != ""
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "mt-1 p-3 d-flex flex-column-reverse flex-md-row justify-content-between w-100 align-items-start align-items-md-center",
                                class:
                                  _vm.theme == "white"
                                    ? "bg-specialbackground-" + _vm.theme
                                    : "bg-third-" + _vm.theme,
                              },
                              [
                                _c("p", { staticClass: "pt-1 pt-md-0" }, [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(_vm.t("general.reparedifficult"))
                                  ),
                                  _c("br"),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(_vm._s(card.repairlevel)),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "svg",
                                  {
                                    attrs: {
                                      id: "help-button",
                                      xmlns: "http://www.w3.org/2000/svg",
                                      width: "19.499",
                                      height: "19.499",
                                      viewBox: "0 0 19.499 19.499",
                                    },
                                  },
                                  [
                                    _c(
                                      "g",
                                      {
                                        attrs: {
                                          id: "Gruppe_1508",
                                          "data-name": "Gruppe 1508",
                                        },
                                      },
                                      [
                                        _c("path", {
                                          attrs: {
                                            id: "Pfad_8248",
                                            "data-name": "Pfad 8248",
                                            d: "M9.75,19.5A9.75,9.75,0,1,1,19.5,9.75,9.76,9.76,0,0,1,9.75,19.5ZM9.75.75a9,9,0,1,0,9,9A9.01,9.01,0,0,0,9.75.75Z",
                                            fill: "#fff",
                                          },
                                        }),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "g",
                                      {
                                        attrs: {
                                          id: "Gruppe_1510",
                                          "data-name": "Gruppe 1510",
                                          transform: "translate(8.801 3.871)",
                                        },
                                      },
                                      [
                                        _c(
                                          "g",
                                          {
                                            attrs: {
                                              id: "Gruppe_1509",
                                              "data-name": "Gruppe 1509",
                                            },
                                          },
                                          [
                                            _c("path", {
                                              attrs: {
                                                id: "Pfad_8249",
                                                "data-name": "Pfad 8249",
                                                d: "M192.667,84.86a.949.949,0,0,1-1.9,0,.933.933,0,0,1,.957-.957A.909.909,0,0,1,192.667,84.86Zm-1.705,10.79V87.227h1.531v8.423Z",
                                                transform:
                                                  "translate(-190.77 -83.903)",
                                                fill: "#fff",
                                              },
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "sparepartsproductselection__productlist__item__details w-100 pl-3 pl-md-5 pt-2 pt-md-1",
                      },
                      [
                        _c("h2", [_vm._v(_vm._s(card.label))]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "row flex-column-reverse flex-md-row pt-0 pt-md-4",
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "col-12 col-md-8 w-100 h-100" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "w-100 h-100 detailContainer position-fixed position-md-static top-0 left-0",
                                    class: [
                                      _vm.detailopen == index ? "open" : "",
                                      "bg-" + _vm.theme,
                                    ],
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "d-flex row mx-0" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "backToSection position-relative w-100 d-flex px-1 py-3 d-md-none justify-content-start align-items-center",
                                            class:
                                              "backToSection--" + _vm.theme,
                                            on: {
                                              click: function ($event) {
                                                return _vm.toggleDetail(
                                                  "undefined"
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm.theme == "white"
                                              ? [
                                                  _c(
                                                    "svg",
                                                    {
                                                      staticClass:
                                                        "position-absolute",
                                                      attrs: {
                                                        xmlns:
                                                          "http://www.w3.org/2000/svg",
                                                        width: "6.774",
                                                        height: "5",
                                                        viewBox: "0 0 6.774 5",
                                                      },
                                                    },
                                                    [
                                                      _c("path", {
                                                        attrs: {
                                                          id: "play-button",
                                                          d: "M4.93,3.254.253.028A.161.161,0,0,0,0,.161V6.613a.161.161,0,0,0,.253.133L4.93,3.52a.161.161,0,0,0,0-.265Z",
                                                          transform:
                                                            "translate(6.774) rotate(90)",
                                                          fill: "#000",
                                                          opacity: "0.8",
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "svg",
                                                    {
                                                      staticClass:
                                                        "d-none cross position-absolute",
                                                      attrs: {
                                                        height: "12",
                                                        viewBox: "0 0 512 512",
                                                        width: "12",
                                                        xmlns:
                                                          "http://www.w3.org/2000/svg",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "g",
                                                        {
                                                          attrs: {
                                                            id: "_02_User",
                                                            "data-name":
                                                              "02 User",
                                                          },
                                                        },
                                                        [
                                                          _c("path", {
                                                            attrs: {
                                                              fill: "#000",
                                                              d: "m25 512a25 25 0 0 1 -17.68-42.68l462-462a25 25 0 0 1 35.36 35.36l-462 462a24.93 24.93 0 0 1 -17.68 7.32z",
                                                            },
                                                          }),
                                                          _vm._v(" "),
                                                          _c("path", {
                                                            attrs: {
                                                              fill: "#000",
                                                              d: "m487 512a24.93 24.93 0 0 1 -17.68-7.32l-462-462a25 25 0 0 1 35.36-35.36l462 462a25 25 0 0 1 -17.68 42.68z",
                                                            },
                                                          }),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              : [
                                                  _c(
                                                    "svg",
                                                    {
                                                      staticClass:
                                                        "position-absolute",
                                                      attrs: {
                                                        xmlns:
                                                          "http://www.w3.org/2000/svg",
                                                        width: "6.774",
                                                        height: "5",
                                                        viewBox: "0 0 6.774 5",
                                                      },
                                                    },
                                                    [
                                                      _c("path", {
                                                        attrs: {
                                                          id: "play-button",
                                                          d: "M4.93,3.254.253.028A.161.161,0,0,0,0,.161V6.613a.161.161,0,0,0,.253.133L4.93,3.52a.161.161,0,0,0,0-.265Z",
                                                          transform:
                                                            "translate(6.774) rotate(90)",
                                                          fill: "#fff",
                                                          opacity: "0.8",
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "svg",
                                                    {
                                                      staticClass:
                                                        "d-none cross position-absolute",
                                                      attrs: {
                                                        height: "12",
                                                        viewBox: "0 0 512 512",
                                                        width: "12",
                                                        xmlns:
                                                          "http://www.w3.org/2000/svg",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "g",
                                                        {
                                                          attrs: {
                                                            id: "_02_User",
                                                            "data-name":
                                                              "02 User",
                                                          },
                                                        },
                                                        [
                                                          _c("path", {
                                                            attrs: {
                                                              fill: "#fff",
                                                              d: "m25 512a25 25 0 0 1 -17.68-42.68l462-462a25 25 0 0 1 35.36 35.36l-462 462a24.93 24.93 0 0 1 -17.68 7.32z",
                                                            },
                                                          }),
                                                          _vm._v(" "),
                                                          _c("path", {
                                                            attrs: {
                                                              fill: "#fff",
                                                              d: "m487 512a24.93 24.93 0 0 1 -17.68-7.32l-462-462a25 25 0 0 1 35.36-35.36l462 462a25 25 0 0 1 -17.68 42.68z",
                                                            },
                                                          }),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                            _vm._v(" "),
                                            _c(
                                              "p",
                                              { staticClass: "py-3 pl-5" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.t("pagination.previous")
                                                  )
                                                ),
                                              ]
                                            ),
                                          ],
                                          2
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "h2",
                                          {
                                            staticClass:
                                              "pl-3 pt-5 d-block d-md-none",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(card.productId) +
                                                " " +
                                                _vm._s(card.label)
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _vm._l(
                                          card.details,
                                          function (detail, index) {
                                            return _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "col-12 pl-3 pl-md-0 pt-2",
                                                class: [
                                                  index % 2 == 0
                                                    ? "col-md-7 col-xl-5"
                                                    : "col-md-5 col-xl-7",
                                                ],
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "pt-4 pt-md-2",
                                                  },
                                                  [
                                                    _c("h3", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.t(
                                                            "general." +
                                                              detail[
                                                                "codeLabel"
                                                              ]
                                                          )
                                                        )
                                                      ),
                                                    ]),
                                                    _vm._v(" "),
                                                    _c(
                                                      "h3",
                                                      { staticClass: "pt-1" },
                                                      [
                                                        _c("span", {
                                                          domProps: {
                                                            innerHTML: _vm._s(
                                                              detail["value"]
                                                            ),
                                                          },
                                                        }),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                      ],
                                      2
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                card.helpvideo != "" && card.helpvideo != null
                                  ? [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "videolink pt-3 pt-md-5 pt-md-2 pt-md-5 d-flex align-items-center",
                                          on: {
                                            click: function ($event) {
                                              _vm.vidopen = index
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "p",
                                            {
                                              staticClass:
                                                "text-secondary-dark",
                                              class:
                                                "text-secondary-" + _vm.theme,
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.t("general.helprepare")
                                                )
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "svg",
                                            {
                                              attrs: {
                                                xmlns:
                                                  "http://www.w3.org/2000/svg",
                                                width: "24",
                                                height: "7.385",
                                                viewBox: "0 0 24 7.385",
                                              },
                                            },
                                            [
                                              _c("path", {
                                                attrs: {
                                                  id: "Pfad_8247",
                                                  "data-name": "Pfad 8247",
                                                  d: "M19.139,8.308v2.9H0v1.223H19.139v3.264L24,11.9Z",
                                                  transform:
                                                    "translate(0 -8.308)",
                                                  fill: _vm.svgcolor1,
                                                  "fill-rule": "evenodd",
                                                },
                                              }),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "videoPopup position-fixed d-flex justify-content-center align-items-center vh-100 min-vw-100",
                                          class: [
                                            _vm.vidopen == index ? "open" : "",
                                          ],
                                          attrs: {
                                            id: "videoPopup-" + card.productId,
                                          },
                                        },
                                        [
                                          _c("iframe", {
                                            attrs: {
                                              src:
                                                card.helpvideo +
                                                "?enablejsapi=1",
                                              title: "YouTube video player",
                                              frameborder: "0",
                                              allow:
                                                "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
                                              allowfullscreen: "",
                                            },
                                          }),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "videoPopupCloser position-fixed",
                                          class: [
                                            _vm.vidopen == index ? "open" : "",
                                          ],
                                          on: {
                                            click: function ($event) {
                                              return _vm.closeYoutubeVideo(
                                                "videoPopup-" + card.productId,
                                                index
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "svg",
                                            {
                                              attrs: {
                                                xmlns:
                                                  "http://www.w3.org/2000/svg",
                                                width: "40",
                                                height: "40",
                                                viewBox: "0 0 40 40",
                                              },
                                            },
                                            [
                                              _c("path", {
                                                attrs: {
                                                  id: "close.2",
                                                  d: "M40,2.357,37.643,0,20,17.643,2.357,0,0,2.357,17.643,20,0,37.643,2.357,40,20,22.357,37.643,40,40,37.643,22.357,20Z",
                                                  fill: "#fff",
                                                },
                                              }),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  : _vm._e(),
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-12 col-md-4 d-flex flex-column align-items-start align-items-md-end pt-0 pt-md-4",
                              },
                              [
                                _vm.basketLoaded == true
                                  ? [
                                      card.accessible == 0
                                        ? _c(
                                            "h4",
                                            {
                                              staticClass:
                                                "accessible accessible0 pt-4",
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.t("general.available")
                                                  )
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      card.accessible == 1
                                        ? _c(
                                            "h4",
                                            {
                                              staticClass:
                                                "accessible accessible1 pt-4",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.t("general.notavailable")
                                                )
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      card.accessible == 2
                                        ? _c(
                                            "h4",
                                            {
                                              staticClass:
                                                "accessible accessible2 pt-4",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.t(
                                                    "general.infutureavailable"
                                                  )
                                                )
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c("p", { staticClass: "price pt-2" }, [
                                        _vm._v(_vm._s(card.price)),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "p",
                                        { staticClass: "price_text pt-1" },
                                        [_vm._v(_vm._s(_vm.t("general.mwst")))]
                                      ),
                                    ]
                                  : _vm._e(),
                                _vm._v(" "),
                                card.accessible == 0 &&
                                _vm.basketLoaded == true &&
                                card.priceValue != 0
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "mt-4 py-2 px-5 d-none d-md-flex into_basket",
                                        on: {
                                          click: function ($event) {
                                            return _vm.addProductToCart(
                                              card.productId
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.t("general.inbasket"))
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.basketLoaded == false
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "mt-4 py-2 px-5 d-none d-md-flex into_basket",
                                        on: {
                                          click: function ($event) {
                                            return _vm.gotosite(_vm.dealerUrl)
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(_vm.t("dealer.near")))]
                                    )
                                  : _vm._e(),
                              ],
                              2
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "mt-1" }),
                  _vm._v(" "),
                  _vm.basketLoaded == true
                    ? [
                        _c(
                          "div",
                          {
                            staticClass:
                              "py-3 px-5 d-flex mt-5 mb-2 d-md-none more_details more_details--mobile justify-content-center",
                            on: {
                              click: function ($event) {
                                return _vm.toggleDetail(index)
                              },
                            },
                          },
                          [
                            _c("p", [
                              _vm._v(_vm._s(_vm.t("general.moredetail"))),
                            ]),
                          ]
                        ),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  card.accessible == 0 &&
                  _vm.basketLoaded == true &&
                  card.price != 0
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "py-3 px-5 d-flex mt-0 mb-2 d-md-none into_basket into_basket--mobile justify-content-center",
                          on: {
                            click: function ($event) {
                              return _vm.addProductToCart(card.productId)
                            },
                          },
                        },
                        [_c("p", [_vm._v(_vm._s(_vm.t("general.inbasket")))])]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.basketLoaded == false
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "py-3 px-5 d-flex mt-0 mb-2 d-md-none into_basket into_basket--mobile justify-content-center",
                          on: {
                            click: function ($event) {
                              return _vm.gotosite(_vm.dealerUrl)
                            },
                          },
                        },
                        [_c("p", [_vm._v(_vm._s(_vm.t("dealer.near")))])]
                      )
                    : _vm._e(),
                ],
                2
              )
            }),
            0
          )
        : _c("div", { staticClass: "py-3 p-lg-0" }, [
            _c(
              "div",
              {
                staticClass: "sparepartslist__landing-page__wrapper p-5",
                class: [
                  _vm.theme == "dark"
                    ? "bg-third-" + _vm.theme
                    : "bg-specialbackground-" + _vm.theme,
                  "text-primary-" + _vm.theme,
                ],
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "sparepartslist__landing-page__icon py-5 d-none justify-content-center",
                  },
                  [
                    _c(
                      "svg",
                      {
                        attrs: {
                          id: "Capa_1",
                          "enable-background": "new 0 0 512 512",
                          viewBox: "0 0 512 512",
                          xmlns: "http://www.w3.org/2000/svg",
                        },
                      },
                      [
                        _c("g", [
                          _c("path", {
                            attrs: {
                              fill: "<?=$svgcolor2?>",
                              d: "m45.5 122h31c8.262 0 15 6.724 15 15l56.84 228.902c-15.773 7-26.84 22.756-26.84 41.098 0 24.814 20.186\n                            45 45 45h17.763c-1.681 4.715-2.763 9.716-2.763 15 0 24.814 20.186 45 45 45s45-20.186 45-45c0-5.284-1.082-10.285-2.763-15h95.526c-1.681\n                            4.715-2.763 9.716-2.763 15 0 24.814 20.186 45 45 45s45-20.186 45-45-20.186-45-45-45h-240c-8.262 0-15-6.724-15-15s6.738-15\n                            15-15h276.416l68.584-240h-384.873l-6.475-25.854-.117.029c-4.878-19.572-22.472-34.175-43.535-34.175h-31c-24.814 0-45 20.186-45 45h30c0-8.276\n                            6.738-15 15-15zm196 345c0 8.276-6.738 15-15 15s-15-6.724-15-15 6.738-15 15-15 15 6.724 15 15zm180 0c0 8.276-6.738 15-15 15s-15-6.724-15-15\n                            6.738-15 15-15 15 6.724 15 15z",
                            },
                          }),
                          _vm._v(" "),
                          _c("path", {
                            attrs: {
                              fill: "<?=$svgcolor2?>",
                              d: "m286.5 0h30v60h-30z",
                            },
                          }),
                          _vm._v(" "),
                          _c("path", {
                            attrs: {
                              fill: "<?=$svgcolor2?>",
                              d: "m191.052 39.539h29.997v59.994h-29.997z",
                              transform:
                                "matrix(.707 -.707 .707 .707 11.181 166.067)",
                            },
                          }),
                          _vm._v(" "),
                          _c("path", {
                            attrs: {
                              fill: "<?=$svgcolor2?>",
                              d: "m366.952 54.538h59.994v29.997h-59.994z",
                              transform:
                                "matrix(.707 -.707 .707 .707 67.094 301.052)",
                            },
                          }),
                        ]),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "h2",
                  {
                    staticClass:
                      "sparepartslist__landing-page__title pb-2 pb-lg-5 pt-5",
                  },
                  [_vm._v(_vm._s(_vm.t("general.noproducts")))]
                ),
                _vm._v(" "),
                _c(
                  "p",
                  { staticClass: "d-none sparepartslist__landing-page__text" },
                  [_vm._v(_vm._s(_vm.t("")))]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "pb-5 sparepartslist__landing-page__actions d-flex justify-content-center",
                  },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "btn-zoom btn-zoom--primary",
                        class: "text-secondary-" + _vm.theme,
                        attrs: { href: "javascript:history.go(-1)" },
                      },
                      [
                        _c("span", [_vm._v(_vm._s(_vm.t("general.gobackto")))]),
                        _vm._v(" "),
                        _c("div", { staticClass: "btn-zoom__bg" }),
                      ]
                    ),
                  ]
                ),
              ]
            ),
          ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }